<template>
  <div class="form-group">
    <label v-if="label">{{ label }}</label>
    <input
      class="form-control"
      :type="type ? type : 'text'"
      :value="value"
      :placeholder="placeholder"
      :class="{
        'is-invalid': field.$error,
        'is-valid': !field.$invalid && value && value.length > 1,
      }"
      v-on:input="updateValue($event.target.value)"
    />
  </div>
</template>
<script>
export default {
  props: ["label", "type", "placeholder", "field", "value", "vmask"],
  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
    },
  },
};
</script>